import { render, staticRenderFns } from "./noZklist.vue?vue&type=template&id=2a384772&scoped=true&"
import script from "./noZklist.vue?vue&type=script&lang=js&"
export * from "./noZklist.vue?vue&type=script&lang=js&"
import style0 from "./noZklist.vue?vue&type=style&index=0&id=2a384772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a384772",
  null
  
)

export default component.exports